/**
 * Lê a consulta inteira em páginas, no formato `{ data, error }` do supabase.
 * O PostgREST corta em 1000 linhas SEM erro (max_rows). Qualquer leitura que
 * pode passar disso (vendas, snapshots, categorias de grupo…) passa por aqui.
 * `ordem` precisa ser única (id) pra página não repetir nem pular linha.
 */
export async function todasAsLinhas<T = any>(
  montar: () => any,
  ordem = "id",
): Promise<{ data: T[] | null; error: any }> {
  const out: T[] = [];
  for (let de = 0; ; de += 1000) {
    const { data, error } = await montar().order(ordem, { ascending: true }).range(de, de + 999);
    if (error) return { data: null, error };
    out.push(...((data ?? []) as T[]));
    if (!data || data.length < 1000) return { data: out, error: null };
  }
}
